module.exports = __webpack_public_path__ + "media/valentines.343ee207.mp4";